import { createContext, useContext, useState } from 'react';

interface PlayerContextValue {
  media: string | null;
  setMedia: (media: string | null) => void;
}

const PlayerContext = createContext<PlayerContextValue | null>(null);

export const PlayerProvider = ({ children }: { children: React.ReactNode }) => {
  const [media, setMedia] = useState<string | null>(null);

  return <PlayerContext.Provider value={{ media, setMedia }}>{children}</PlayerContext.Provider>;
};

export const usePlayerContext = () => {
  const context = useContext(PlayerContext);
  if (!context) {
    throw new Error('usePlayerContext must be used within a PlayerProvider');
  }
  return context;
};
